export default __webpack_public_path__ + "static/media/loginLogo.a3ef3400.png";